import * as React from 'react';
import { ModalBase } from '../components/ModalBase';
import { useChangeSubscription } from '../hooks/useChangeSubscription';
import { Box, TextField } from '@mui/material';
import { InputBaseSx } from '../@shared/templates';

export const withChangeSubscription = <T extends Record<string, unknown>>(
  Component: React.ComponentType<T>
): React.FC<T> => (props) => {
  const {
    onSetLicenseIdValue,
    licenseIdValue,
    isLoading,
    onChange,
    setIsDialogOpen,
    isDialogOpen
  } = useChangeSubscription();

  const onChangeId = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onSetLicenseIdValue(e.target.value);
  }

  return <>
    <ModalBase
      isOpen={isDialogOpen}
      onCancel={() => setIsDialogOpen(false)}
      onSave={onChange}
      title="Apply subscription"
      isProcessing={isLoading}
    >
      <Box>
        <TextField size="small" fullWidth sx={{ ...InputBaseSx, marginBottom: "10px" }} onChange={onChangeId} value={licenseIdValue} className='' label="Subscription Key" variant="outlined" />
      </Box>

    </ModalBase>
    <Component {...props as T} />
  </>
}